export class DeleteAttachmentError extends Error {
}